/* eslint-disable react/prop-types */
/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import theme from "../../../theme/settings";
import { typography } from "../../../styles/typography";
const Labels = ({
  getX,
  getY,
  data,
  labelsColor,
  labelsCountY,
  labelsFormatX,
  viewBoxWidth,
  labelsFormatY,
  labelsHeightX,
  labelsOffsetX,
  labelStyle,
  labelsOffsetY,
  labelsVisible,
  maxY,
  minX,
  unitWidth
}) => {
  const labelContainerCSS = css`
        transform: translate(0, ${labelsOffsetX}px);
    `;
  const Label = css`
        align-items: center;
        justify-content: center;
        text-align: center;
    `;
  const LabelCSS = labelStyle === 'italic' ? css`
                  fill: ${theme.colors.system.rest};
                  text-anchor: start;
                  ${typography.paragraph3};
                  text-transform: capitalize;
                  cursor: pointer;
                  display: inline-block;
                  transform-box: fill-box;
                  transform: rotateZ(45deg);
              ` : css`
                  color: ${theme.colors.system.rest};
                  text-anchor: middle;
                  ${typography.paragraph3};
                  text-transform: capitalize;
                  cursor: pointer;
                  display: inline-block;
                  word-break: break-word;
              `;
  const TextCSS = css`
        ${typography.paragraph3};
        fill: ${theme.colors.system.rest};
        cursor: 'pointer';
    `;
  if (labelsVisible) {
    let xLabels;
    let yLabels;
    let tile = 4;
    let tile2 = 9;
    const TiLe = () => {
      if (viewBoxWidth >= 800) {
        return tile;
      } else {
        return tile2;
      }
    };
    xLabels = labelStyle === 'italic' ? data.map((point, x) => jsx("text", {
      key: x,
      css: LabelCSS,
      fill: labelsColor,
      x: getX(point.x + unitWidth / 2),
      y: getY(0) + labelsHeightX
    }, labelsFormatX(point.name))) : data.map((point, x) => jsx("foreignObject", {
      key: x,
      css: Label,
      x: getX(point.x + unitWidth / TiLe()),
      y: getY(0) + labelsHeightX,
      width: "40",
      height: "80"
    }, jsx("span", {
      css: LabelCSS
    }, labelsFormatX(point.name))));
    const yLabelsRange = [];
    const yStep = labelsCountY > 0 ? labelsCountY : 1;
    for (let i = 0; i <= maxY; i += Math.floor(maxY / yStep)) {
      yLabelsRange.push(i);
    }
    yLabels = yLabelsRange.map(quantity => jsx("text", {
      key: quantity,
      fill: labelsColor,
      x: getX(minX),
      y: getY(quantity) + labelsHeightX / 3,
      transform: `translate(-${labelsOffsetY}, 0)`,
      textAnchor: "end",
      css: TextCSS
    }, labelsFormatY(quantity)));
    return jsx("g", {
      className: 'DGN-Labels-BarChart'
    }, xLabels && jsx("g", {
      className: 'DGN-AxisX',
      css: labelContainerCSS
    }, xLabels), yLabels && jsx("g", {
      className: 'DGN-AxisY'
    }, yLabels));
  } else {
    return null;
  }
};
Labels.defaultProps = {
  getX: x => x,
  getY: quantity => quantity,
  labelsCharacterWidth: 10,
  labelsColor: theme.colors.system.rest,
  labelsCountY: 5,
  labelsFormatX: label => label,
  labelsFormatY: quantity => quantity,
  labelsHeightX: 5,
  labelsOffsetX: 10,
  labelsOffsetY: 10,
  labelsStepX: 1,
  labelsVisible: true,
  unitWidth: 1,
  labelStyle: 'italic'
};
Labels.propTypes = {
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** the labelsColor change color */
  labelsColor: PropTypes.string,
  /** change style show of label ['', 'italic'], default: 'italic' */
  labelStyle: PropTypes.string,
  labelsCountY: PropTypes.number,
  labelsFormatX: PropTypes.func,
  labelsFormatY: PropTypes.func,
  labelsHeightX: PropTypes.number,
  labelsOffsetX: PropTypes.number,
  labelsOffsetY: PropTypes.number,
  labelsStepX: PropTypes.number,
  /** change show or hiden of label */
  labelsVisible: PropTypes.bool,
  /** the maxX is maximum of Ox quantity returned by data*/
  maxX: PropTypes.number,
  /** the maxY is maximum of Oy quantity returned by data*/
  maxY: PropTypes.number,
  /** the minX is minimum of OX quantity returned by data*/
  minX: PropTypes.number,
  /** the minY is minimum of Oy quantity returned by data*/
  minY: PropTypes.number,
  /** the unitWidth */
  unitWidth: PropTypes.number
};
export default Labels;